module.exports = __webpack_public_path__ + "img/treatment-satisfaction.4f6994e2.svg";